import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
// import AddProduct from '../components/dashboard/AddProduct';
// import { AuthContext } from '../helper/AuthContext';
import '../../src/App.css';
import DashSidebar from '../components/dashboard/DashSidebar';
import DashChart from '../components/dashboard/DashChart';

function Dashboard() {
    // const navigate = useNavigate();

    // const handleLogout = () => {
    //     localStorage.removeItem('token');
    //     localStorage.removeItem('user');
    //     navigate('/login');
    // };
    // const location = useLocation();

    // Determine the active class based on the current route
    const location = useLocation();
    const getActiveClass = (route) => {
        return location.pathname === route ? "active" : "";
    };

    return (
        <>
            <section className='mt-3'>
                {/* <AddProduct /> */}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-2">
                            <DashSidebar activeClass={getActiveClass("/dashboard")} />
                        </div>
                        <div className="col-sm-10 light-border p-4">
                            <h1>API Data Chart Example</h1>
                            <DashChart />
                            <img className="w-100" src={require('../../src/assets/Pandora1.png')} alt="" />
                        </div>
                    </div>

                </div>
            </section>


        </>
    )
}

export default Dashboard
